import { get } from '../utils/axios'

export const getPhonesAPI = async () => {
  return await get('phones')
}